export default __webpack_public_path__ + "static/media/ReviewsHamburgerIcon.6b8702b4.svg";